<script>
    export default {
        /////////////////////////////////////////////////////
        // Data
        /////////////////////////////////////////////////////
        data() {
            return {
                step: 0
            }
        },
        /////////////////////////////////////////////////////
        // Props
        /////////////////////////////////////////////////////
        props: {},
        /////////////////////////////////////////////////////
        // Mounted
        /////////////////////////////////////////////////////
        mounted() {
            this.step = parseInt(window.top.location.hash.replace('#', ''))
            window.top.addEventListener('hashchange', this.stepchange, false)
        },
        /////////////////////////////////////////////////////
        // Computed
        /////////////////////////////////////////////////////
        computed: {
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        methods: {
            nextStep() {
                this.broadcastEvent('next-step')
            },
            broadcastEvent(msg) {
                var event = new CustomEvent('myEvent', {detail: msg})
                window.top.document.dispatchEvent(event)
            },
            stepchange() {
                this.step = parseInt(window.top.location.hash.replace('#', ''))
            }
        }
    }

</script>



// WEBPACK FOOTER //
// _vue/components/Page-08-Iframe-01.vue